import * as React from 'react';

export default class EmptyComponent extends React.Component<any, any> {
  public render() {
    return (
      <div>Nada</div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Module/Types/Empty.tsx